/* eslint-disable @typescript-eslint/ban-types */
interface ApiResponse {
  requestId: string;
  result: {
    result_code: number;
    /**
     * 'D' : 즉시 지급
     * 'G' : 선물함 지급
     */
    reward_type: 'D' | 'G';
    requestId?: string;
    message?: string;
  };
}

// eslint-disable-next-line unicorn/prevent-abbreviations
interface ApiParams {
  actionType: string;
  recommendCode: string;
  couponSerial: string;
}

interface RedeemResult {
  result: null | { result_code: number; requestId?: string; message?: string };
  error: null | string | Error;
}

export class RedeemApi {
  constructor(private readonly endpoint: string = '') {}

  async redeem({
    actionType,
    recommendCode,
    couponSerial,
  }: ApiParams): Promise<RedeemResult> {
    try {
      const response = await fetch(this.endpoint + '/api/redeem', {
        method: 'POST',
        cache: 'no-cache',
        credentials: 'omit',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action_type: actionType,
          recommend_code: Number(recommendCode),
          coupon_serial: couponSerial,
        }),
      });

      if (response.status !== 200) {
        return {
          result: null,
          error: 'Request failed',
        };
      }

      const data = (await response.json()) as unknown as ApiResponse;

      if (data.result) {
        return {
          result: {
            requestId: data.requestId,
            ...data.result,
          },
          error: null,
        };
      }

      return {
        result: null,
        error: 'Invalid response',
      };
    } catch (error: unknown) {
      console.log(error);

      return {
        result: null,
        error: error as any, // eslint-disable-line @typescript-eslint/no-unsafe-assignment
      };
    }
  }
}
